import Joi from 'joi';

export const RegionSchema = Joi.object({
  name: Joi.string().required(),
  shortName: Joi.string().required(),
  color: Joi.string().required(),
});
